import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.79175 18.958H6.04175C2.58341 18.958 1.04175 17.4163 1.04175 13.958V10.208C1.04175 6.74967 2.58341 5.20801 6.04175 5.20801H9.79175C13.2501 5.20801 14.7917 6.74967 14.7917 10.208V13.958C14.7917 17.4163 13.2501 18.958 9.79175 18.958ZM6.04175 6.45801C3.27508 6.45801 2.29175 7.44134 2.29175 10.208V13.958C2.29175 16.7247 3.27508 17.708 6.04175 17.708H9.79175C12.5584 17.708 13.5417 16.7247 13.5417 13.958V10.208C13.5417 7.44134 12.5584 6.45801 9.79175 6.45801H6.04175Z",
		fill: "#8E68F7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.3334 8.12533C17.9918 8.12533 17.7084 7.84199 17.7084 7.50033C17.7084 5.03366 15.9918 2.96699 13.6834 2.42533L13.9084 2.80033C14.0834 3.10033 13.9918 3.48366 13.6918 3.65866C13.3918 3.83366 13.0084 3.74199 12.8334 3.44199L11.9584 1.98366C11.8418 1.79199 11.8418 1.55033 11.9501 1.35866C12.0668 1.16699 12.2751 1.04199 12.5001 1.04199C16.0584 1.04199 18.9584 3.94199 18.9584 7.50033C18.9584 7.84199 18.6751 8.12533 18.3334 8.12533Z",
		fill: "#8E68F7"
	})]
});
export default SvgRotateLeft;
